import { render, staticRenderFns } from "./WorkingDrawer.vue?vue&type=template&id=527ff085"
import script from "./WorkingDrawer.vue?vue&type=script&lang=js"
export * from "./WorkingDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports